import type { FormType } from "../types"

export function normalizeEmailForApi(value: string): string {
  return value.trim().toLowerCase()
}

export function normalizeSubdomainForApi(value: string): string {
  return value.trim().toLowerCase()
}

/** Lowercase email & subdomain only when sending to BE (input may stay mixed-case). */
export function buildRegistrationPayload(value: FormType): FormType {
  return {
    ...value,
    company_account: normalizeEmailForApi(value.company_account),
    subdomain: normalizeSubdomainForApi(value.subdomain),
  }
}
